import React from 'react';
import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';
import { InspectionChecklist } from '../common';

export const SampleCheckDetails: React.FC<DynamicComponentProps> = (
  props: DynamicComponentProps
) => {
  return (
    <InspectionChecklist
      {...props}
      defaultHeader="Sample Check Details"
      completionTranslationKey="gold_seal_sample_check_complete"
    />
  );
};
